import { render, staticRenderFns } from "./TemporaryControls.vue?vue&type=template&id=3de5ac46"
import script from "./TemporaryControls.vue?vue&type=script&lang=js"
export * from "./TemporaryControls.vue?vue&type=script&lang=js"
import style0 from "./TemporaryControls.vue?vue&type=style&index=0&id=3de5ac46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports